import * as React from 'react';
import * as I18n from 'i18n-js';

import { ICountry } from '../schemas/core-schema';
import { IAddressFormData } from './addresses/address_form_data';
import AddressFormFields from './address_form_fields';

import Tooltip from '@reverbdotcom/commons/dist/components/tooltip';

interface IProps {
  address: IAddressFormData;
  countries: ICountry[];
  defaultCountryCode: string;
  fieldPrefix: string;
}

export default function CheckoutShippingAddressFormFields({ address, countries, defaultCountryCode, fieldPrefix }: IProps) {
  const tooltip = <Tooltip text={I18n.t('discovery.checkoutShippingAddressFormFields.tooltip')}>{I18n.t('discovery.checkoutShippingAddressFormFields.phoneLabelText')}</Tooltip>;

  return (
    <AddressFormFields
      address={address}
      countries={countries}
      defaultCountryCode={defaultCountryCode}
      fieldPrefix={fieldPrefix}
      phoneFieldRequired
      phoneLabel={tooltip}
      shouldTrackView
    />
  );
}
